export const DEFAULT_FEATURED_BANNER_OPTIONS = {
    animation: {
        displayTime: 3,
        type: 'fading'
    },
    controls: {
        bullets: {
            enabled: false
        },
        arrows: {
            enabled: false
        },
        buttons: {
            enabled: false
        }
    }
};

export const WIDGET_OPTIONS = {
    animation: {
        displayTime: 3,
        type: 'monoSlider'
    },
    controls: {
        bullets: {
            enabled: true
        },
        arrows: {
            enabled: true
        },
        buttons: {
            enabled: false
        }
    }
};

export const DOTS_OPTION = 'dots';
export const DISABLE_ROTATION_URL_PARAM = 'no_banner_rotation';

export const BANNER_HEIGHT_DESKTOP = '300px';
export const BANNER_HEIGHT_MOBILE = '41.66vw';
export const ADDITIONAL_BLOCK_HEIGHT = '7rem';
export const TERMS_BLOCK_HEIGHT_MOBILE = '2.3rem';
export const TERMS_BLOCK_HEIGHT = '3.3rem';
export const TERMS_AND_ADDITIONAL_BLOCKS_HEIGHT = '9rem';
